import { RouteRecordRaw } from "vue-router"
import { routePaths } from "../routePaths"

const governRoutes: RouteRecordRaw[] = [
  {
    path: "/govern",
    name: "govern",
    component: () => import("@/layout/AbstractRouteView.vue"),
    meta: {
      isProtected: true
    },
    children: [
      {
        path: routePaths.govern.policy.path,
        name: routePaths.govern.policy.pathName,
        component: () => import("@/modules/govern/policies/pages/Policies.vue"),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "Govern",
              translationKey: "sideMenu.govern",
              routeName: ""
            },
            {
              title: "My Policies",
              translationKey: "sideMenu.myPolicies",
              routeName: ""
            }
          ]
        }
      },
      {
        path: routePaths.govern.subscribedAgreements.path,
        name: routePaths.govern.subscribedAgreements.pathName,
        component: () =>
          import("@/modules/govern/subscribedAgreements/pages/SubscribedAgreements.vue"),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "Govern",
              translationKey: "sideMenu.govern",
              routeName: ""
            },
            {
              title: "Subscribed data agreements",
              translationKey: "sideMenu.subscribedAgreements",
              routeName: ""
            }
          ]
        }
      },
      {
        path: routePaths.govern.outgoingAgreements.path,
        name: routePaths.govern.outgoingAgreements.pathName,
        component: () =>
          import("@/modules/govern/subscribedAgreements/pages/OutgoingAgreements.vue"),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "Govern",
              translationKey: "sideMenu.govern",
              routeName: ""
            },
            {
              title: "Outgoing data agreements",
              translationKey: "sideMenu.outgoingAgreements",
              routeName: ""
            }
          ]
        }
      },
      {
        path: routePaths.govern.publicationTemplates.path,
        name: routePaths.govern.publicationTemplates.pathName,
        component: () =>
          import("@/modules/govern/publicationTemplates/pages/PublicationTemplates.vue"),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "Govern",
              translationKey: "sideMenu.govern",
              routeName: ""
            },
            {
              title: "Publication templates",
              translationKey: "sideMenu.publicationTemplates",
              routeName: ""
            }
          ]
        }
      }
    ]
  }
]

export default governRoutes
